import { render } from "./P022.vue?vue&type=template&id=6c316adf&scoped=true"
import script from "./P022.vue?vue&type=script&lang=js"
export * from "./P022.vue?vue&type=script&lang=js"

import "./P022.vue?vue&type=style&index=0&id=6c316adf&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c316adf"]])

export default __exports__